
































































import Vue from 'vue';
import { getStampList, clickRegister } from '../api';
import homeStore from '../views/stores/home.js';
import { biHT } from '@/business/bi';
import { updateRedDot } from '@/business/red-dot';
import { FitLayout, FitWxPhonex } from '@tencent/wphk-ui';
import VueBetterScroll from 'vue2-better-scroll';
import dayjs from 'dayjs';
import { i18n } from '@/i18n';
import { to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import { NoticeItem } from '@/types/index';
import { getDiscountListData } from '@/business/homev3/index';
import Notice from '@/components/v3/notice/index.vue';

function getLogoList(id, backgroundUrl) {
  if (backgroundUrl) {
    return backgroundUrl;
  }
  const logoList = window.discount_stamp_bg || [];
  for (let i = 0, iLen = logoList.length; i < iLen; i++) {
    if (id === logoList[i].active_id) {
      return logoList[i].logo_url;
    }
  }
}
/**
 * 获取正在进行中的活动
 * 动列表只展示进行中的活动（即活动开始时间 > 当前时间 > 活动结束时间）【未到活动开始时间的活动】和【已过活动结束时间的活动】不在【优惠专区首页的活动列表】中展示
 * @param  {[type]} actList [description]
 * @return {[type]}         [description]
 */

export default Vue.extend({
  name: 'stamplist',
  components: {
    FitWxPhonex,
    FitLayout,
    VueBetterScroll,
    Notice,
  },
  data() {
    return {
      listData: [] as NoticeItem[],
      stamp: '',
      showList: true,
      page_num: 1,
      is_working: 1,
      homeStore,
    };
  },
  async created() {
    document.title = homeStore.STAMP_LIST_TITLE;
    // 承接原 HeaderTab 下线后失去的印花访问上报（visit_type=2）
    updateRedDot('stamplist');
    // 获取信息
    await this.getStamp();
    await this.markStampReddot();
    this.getNoticeData();
    biHT('promozone.stamplist_brow');
  },
  methods: {
    async getStamp() {
      showLoading();
      const [err, stamp] = await to(
        getStampList({
          page_size: '20',
          page_num: '0',
          is_working: '1',
        })
      );
      hideLoading();
      console.log('stamp: ', stamp);
      if (err) {
        throw new CustomException(err, 'qryStampListFail');
      }
      this.stamp = stamp;
      this.showList = stamp.length > 0;
    },
    async getNoticeData() {
      this.listData = await getDiscountListData();
    },
    /** 是否简单展示印花信息 */
    isSimpleShowStamp(stamp) {
      const qualIdList = ['F995Diey2R9ohHZ+pkyZNw=='];
      return qualIdList.includes(stamp.qual_id);
    },
    getLogo(id, backgroundUrl) {
      return getLogoList(id, backgroundUrl);
    },
    /** 有效期 */
    getExpireDate(stamp) {
      const formatDate = dayjs(stamp.exch_end_time).format('YYYY.MM.DD');
      return i18n('有效期至{{date}}', { date: formatDate });
    },
    /** 是否展示红点 */
    isShowStampRedDot(stamp) {
      return +stamp.red_point === 1;
    },
    goDetail(list) {
      biHT('promozone.stamplist.stampcard_click');
      setTimeout(() => {
        let jumpUrl = list;
        if (
          list ===
          'https://prom.wechatpay.com.hk/mojo/prom/app_4_889/index.shtml'
        ) {
          jumpUrl =
            'https://prom.wechatpay.com.hk/mojo/prom/app_4_889/index.shtml?ADTAG=stampcard&promv=sc25';
        }
        location.href = jumpUrl;
      }, 300);
    },
    getTips(list) {
      const prize = list.prize_list;

      let minPrize;
      // 取最小活动信息
      prize.map((item) => {
        minPrize =
          minPrize === undefined
            ? parseInt(item.prize_price, 10)
            : parseInt(minPrize, 10);
        minPrize =
          parseInt(item.prize_price, 10) < minPrize
            ? parseInt(item.prize_price, 10)
            : minPrize;
      });
      // 是否可领取
      const usableStamp =
        parseInt(list.total_cnt, 10) - parseInt(list.used_cnt, 10);
      let tips = '';
      if (usableStamp >= minPrize) {
        tips = homeStore.HAVE_PRIZE;
      } else {
        if ((minPrize - usableStamp).toString() === '1') {
          tips = `${homeStore.NEED_MORE} ${(
            minPrize - usableStamp
          ).toString()} ${homeStore.NEED_ONE_TIPS}`;
        } else {
          tips = `${homeStore.NEED_MORE} ${(
            minPrize - usableStamp
          ).toString()} ${homeStore.NEED_MORE_TIPS}`;
        }
      }
      return tips;
    },
    renderUnable() {
      biHT('promozone.stamplist.previousstampcard_click');
      this.$router.push({ name: 'unusestamplist' });
    },
    /** 标记印花卡红点 */
    async markStampReddot() {
      await to(clickRegister({ visit_type: '4' }));
    },
  },
});
